var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72726 10.9556V9.84937C9.72726 9.2626 9.4974 8.69987 9.08823 8.28496C8.67906 7.87006 8.1241 7.63696 7.54545 7.63696H3.18182C2.60316 7.63696 2.04821 7.87006 1.63904 8.28496C1.22987 8.69987 1 9.2626 1 9.84937V10.9556",
    stroke: "#2D4370",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36346 5.4248C6.56845 5.4248 7.54529 4.43428 7.54529 3.2124C7.54529 1.99053 6.56845 1 5.36346 1C4.15848 1 3.18164 1.99053 3.18164 3.2124C3.18164 4.43428 4.15848 5.4248 5.36346 5.4248Z",
    stroke: "#2D4370",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 10.9558V9.84957C12.9993 9.35935 12.8384 8.88314 12.5422 8.4957C12.246 8.10826 11.8313 7.83154 11.3633 7.70898",
    stroke: "#2D4370",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18164 1.07202C9.65096 1.19387 10.0669 1.47065 10.364 1.85872C10.6611 2.24679 10.8223 2.72407 10.8223 3.21533C10.8223 3.70659 10.6611 4.18388 10.364 4.57194C10.0669 4.96001 9.65096 5.23679 9.18164 5.35864",
    stroke: "#2D4370",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.cc48148b1d46e136aaae35a05f97572f.svg";
export { ForwardRef as ReactComponent };